import React from "react";
import useRouter from "use-react-router";
import { useStore } from "lib/store/useStore";
import { actionLogout, actionLogin } from "lib/store/Actions";
import {
  client,
  createAuthenticatedClient,
  createMessagesClient,
  createAuth,
} from "lib/api";
import Login from "./public/Login";
import Main from "./Main";
import Loading from "Loading";

const AuthGate: React.FunctionComponent<{}> = () => {
  const [loading, setLoading] = React.useState(true);
  const [state, dispatch] = useStore();
  const { history } = useRouter();

  React.useEffect(() => {
    if (!loading) return;
    client
      .POST("/api/auth/refresh")
      .then((r) => {
        if (!r.error) {
          const auth = createAuth(r.data.token, () => {
            dispatch(actionLogout());
            history.push("/");
          });
          const messages = createMessagesClient(auth);
          const client = createAuthenticatedClient(auth);
          client
            .GET("/api/orgs/{org}", {
              params: { path: { org: auth.user.org } },
            })
            .then((r) => {
              if (!r.error) {
                const org = r.data;
                dispatch(actionLogin(auth.user, client, org, messages));
              }
            });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [loading, dispatch, history]);

  return (
    <div className="App">
      {loading && <Loading />}
      {!loading && !state.isAuthenticated && <Login />}
      {!loading && state.isAuthenticated && <Main />}
    </div>
  );
};

export default AuthGate;
